class CardQuantityInput extends QuantityInput {
    #notifyAt = undefined;
    #notificationEl = undefined;

    constructor() {
        super();
    }

    connectedCallback() {
        this.#notificationEl = this.nextElementSibling || this.parentElement.nextElementSibling;
        this.input.addEventListener("change", this.onChange.bind(this));
        document.addEventListener("cardQtyInput:change", this.onUpdate.bind(this));
    }

    onUpdate(e) {
        const { variantId, quantity } = e.detail;

        if (variantId !== this.dataset.variantId) return;

        this.input.value = quantity;
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

        if (previousValue !== this.input.value)
            this.input.dispatchEvent(this.changeEvent);
    }

    onChange(event) {
        const changeEvent = new CustomEvent("cardQtyInput:change", {
            detail: {
                variantId: this.dataset.variantId,
                quantity: Number(this.input.value)
            }
        });

        document.dispatchEvent(changeEvent)

        this.updateCart();
        
    }

    async updateCart() {
        const inCart = this.dataset.inCart == "true";
        const END_POINT = inCart ? "/cart/change.js" : "/cart/add.js";
        const quantity = Number(this.input.value);
        const sections = this.getSectionsToRender().map((section) => section.id);
        let item = { sections, sections_url: window.location.pathname };

        if (inCart) {
            let key = this.dataset.cartKey || this.dataset.variantId;

            item = { ...item, id: key, quantity };
        } else {
            item = {
                ...item,
                items: [
                    {
                        id: this.dataset.variantId,
                        quantity,
                    },
                ],
            };
        }

        try {
            const response = await fetch(END_POINT, {
                method: "POST",
                body: JSON.stringify(item),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            this.#notificationEl.classList.remove("is-hidden");
            setTimeout(() => this.#notificationEl.classList.add("is-hidden"), 2000);

            const data = await response.json();
            this.getSectionsToRender().forEach((section) => {
                if (document.getElementById(section.id)) {
                    document.getElementById(section.id).innerHTML =
                        this.getSectionInnerHTML(
                            data.sections[section.id],
                            section.selector,
                        );
                }
            });

            this.dataset.inCart = true;
        } catch (error) {
            console.log(error);
        }
    }

    getSectionsToRender() {
        return [
            {
                id: "mini-cart",
                section: "mini-cart",
                selector: ".shopify-section",
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
            },
            {
                id: "mobile-cart-icon-bubble",
                section: "mobile-cart-icon-bubble",
                selector: ".shopify-section",
            },
        ];
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }
}

customElements.define("card-quantity-input", CardQuantityInput);
